import React from 'react';
import { Link } from 'react-router-dom';
import FullLogo from '../Photos/Fulllogo.png';
import GeneralImage from '../Photos/generalimage.jpg';

import Custom1 from '../Photos/Custom1.jpg';
import Custom2 from '../Photos/custom2.jpg';
import Custom3 from '../Photos/custom3.jpg';
import Custom4 from '../Photos/custom4.jpg';
import Custom5 from '../Photos/custom5.jpg';
import Custom6 from '../Photos/Custom6.jpg';
import Materials1 from '../Photos/Materials1.jpg';
import Feederpanel from '../Photos/feederpanel3.jpg'
import Feederpanel1 from '../Photos/feederpanels1.jpg'
import Custom7 from '../Photos/Custom7.jpg';
import Custom8 from '../Photos/Custom8.jpg';
import Custom9 from '../Photos/Custom9.jpg';
import Custom10 from '../Photos/Custom10.jpg';
import Custom11 from '../Photos/Custom11.jpg';

function PurposeBuilt() {
  return (
    <div className="container mt-5">
     


      {/* Introduction Section */}
      <div className="row mt-5 mb-5 align-items-center">
        <div className="col-md-4">
          <img src={Custom9} alt="Side Image" className="img-fluid rounded" />
        </div>
        <div className="col-md-8">
          <h2 className="text-success">We build for You</h2>
          <p className="lead">We can build what you need, whether it is a complete movable sorting facility or just pre-cut posts. We will work with you to design what will work best for you.</p>
          <p className="text-muted">Explore our pages to get an idea of what you're looking for. Don't hesitate to reach out!</p>
        </div>
      </div>

      {/* Informational Box with Image on Right */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Prebuilt Buildings</h4>
              <p className="card-text">We build durable custom buildings that can be set in place quickly, giving you dependable protection from the elements. The interior can be customized with a variety of gates and features for your specific application.</p>
              <a href="#contact-details" className="btn btn-link p-0 text-decoration-none get-in-touch-link">Get in Touch</a>
            </div>
          </div>
          <div className="col-md-4">
            <img src={Custom1} className="img-fluid rounded-end" alt="Info Image" />
          </div>
        </div>
      </div>

      {/* Informational Box */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={Custom5} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Complete Systems</h4>
              <p className="card-text">We’d love to help you build a complete working facility including budbox, sorting pen, and alleyway. We can design and build it freestanding so that it is movable or design permanent sections for a lifetime of rigidity.</p>
              <a href="#contact-details" className="btn btn-link p-0 text-decoration-none get-in-touch-link">Contact Us</a>
            </div>
          </div>
        </div>
      </div>

      {/* Informational Box with Image on Right */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Specialty Panels</h4>
              <p className="card-text">We build a variety of specialty panels, including feeder panels, custom-length panels, and panels with swinging gates. Whatever your needs are, we can build it for you.</p>
              <a href="#contact-details" className="btn btn-link p-0 text-decoration-none get-in-touch-link">Get in Touch</a>
            </div>
          </div>
          <div className="col-md-4">
            <img src={Custom8} className="img-fluid rounded-end" alt="Info Image" />
          </div>
        </div>
      </div>

      {/* Informational Box */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={Materials1} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Materials</h4>
              <p className="card-text">If you have your own project you want done, we can work with you to get the materials you need. Whether you just need individual sticks of pipe or pre-cut posts and braces, come to us to get what you need!</p>
              <a href="#contact-details" className="btn btn-link p-0 text-decoration-none get-in-touch-link">Get in Touch</a>
            </div>
          </div>
        </div>
      </div>


      {/* Additional Images */}
      <div className="row g-4 mb-5">
        <div className="col-md-4">
          <img src={Custom11} alt="Image 1" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
        <div className="col-md-4">
          <img src={Custom2} alt="Image 2" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
        <div className="col-md-4">
          <img src={Custom10} alt="Image 3" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
      </div>

      {/* Google Maps and Address Section */}
      <div className="row mb-5" id="contact-details">
        <div className="col-md-6">
          <h3 className="text-info mb-3">Find Us on the Map</h3>
          <iframe
            title="Google Map Location"
             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d137778.5034484805!2d-96.8170804273567!3d40.26456281736707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x879642a907fb410b%3A0x92e39ab059d18d3d!2sBeatrice%2C%20NE%2068310!5e0!3m2!1sen!2sus!4v1756762112857!5m2!1sen!2sus" 
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <div className="col-md-6 d-flex flex-column">
          <h3 className="text-info mb-3">Contact Us</h3>
          <div className="card p-3 enlarged-address-card flex-grow-1">
            <p className="card-text">
             Location: <br />
              
            
              Beatrice, NE 68310<br />
              <br />
              <br />
              Email: eoltmans3@gmail.com<br />
              <br />
              Phone: (402) 239-4323
            </p>
          </div>
          <div className="flex-grow-1 mt-3">
            <img src={FullLogo} alt="Company Logo" className="img-fluid w-100" style={{ width: '100%', objectFit: 'cover' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PurposeBuilt;